import React, { RefObject, useEffect, useState } from "react";
import "./style.scss";
import { ReactComponent as ShiftIcon } from "../../assets/icons/shift.svg";
import { ReactComponent as BackspaceIcon } from "../../assets/icons/backspace.svg";

export interface KeyboardProps {
    text: string;
    clearRef?: RefObject<any>;
    onChangeText: (text: string) => void;
}

const keys = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
    ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
    ["shift", "z", "x", "c", "v", "b", "n", "m", "backspace"]
];

const Keyboard = ({text, clearRef, onChangeText}: KeyboardProps) => {

    const [isShift, setIsShift] = useState<boolean>(false);

    useEffect(() => {
        let clear = clearRef?.current;

        if (clear) {
            clear.addEventListener("click", onClearClick);
        }

        return () => {
            if (clear)
                clear.removeEventListener("click", onClearClick);
        }

    }, [clearRef]);

    const onClearClick = () => {
        onChangeText("");
    }

    const getButtonValue = (key: string): string | React.JSX.Element => {
        let r: string | React.JSX.Element = key;

        switch(key) {
            case "shift":
                r = <ShiftIcon className="shift" />
                break;
            case "backspace":
                r = <BackspaceIcon className="backspace" />
                break;
        }

        return r;
    }

    const isUpper = (): boolean => {
        let upper = false;
        if (isShift) {
            upper = true;
        }

        if (!text.length)
            upper = !upper;

        return upper;
    }

    const pressKey = (key: string) => {
        switch(key) {
            case "shift":
                setIsShift(!isShift);
                break;
            case "backspace":
                onChangeText(text.substring(0, text.length - 1));
                break;
            default:
                key = isUpper() ? key.toUpperCase() : key.toLowerCase();
                onChangeText(text + key);
                setIsShift(false);
        }
    }

    return <div className="Keyboard">
        {keys.map((row, i) => <div key={`row_${i}`} className="row">
            {row.map(x => <div
                            key={`key_${x}`}
                            className={`key ${x === "shift" || x === "backspace" ? "dark" : ""} ${isUpper() ? "upper" : ""} ${x === "shift" && isUpper() ? "gray" : ""}`}
                            onClick={() => pressKey(x)}
                            >
                                {getButtonValue(x)}
                            </div>
            )}
        </div>)}
    </div>
}

export default Keyboard;
